module.exports = __webpack_public_path__ + "img/+.08237d81.svg";